import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Button = styled.button`
  position: relative;
  width: 120px;
  padding: 14px 0;
  font-family: "Maison Neue Bold", sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;
  background: #fff;
  margin-right: 8px;
  border-radius: 4px;
  color: ${({ color }) => (color ? color : "#4D4C4D")};
  border: ${({ color }) =>
		color ? `1px solid ${color}` : "1px solid #4D4C4D"};

  &:disabled {
    background: #807e80;
    border-color: ${({ color }) => (color ? "#807E80" : "#4D4C4D88")};
  }

  ${({ variant }) =>
		variant === "primary" &&
		`
    background: #9036F7;
    color: white;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 0px;
    `};
`;

class FormActions extends React.Component {
	render() {
		return (
			<div className="text-right" style={{ marginTop: "24px" }}>
				{!this.props.hideCancel ? (
					<Link to={`/dashboard/${this.props.module}`}>
						<Button variant="secondary" color="#9036F7" type="button"
							style={{
								border: "none",
								textDecoration: "underline",
								backgroundColor: "transparent",
							}}
						>
							Cancelar
						</Button>
					</Link>
				) : null}

				{this.props.backButton && this.props.hideCancel ? (
					<Button
						variant="secondary"
						color="#9036F7"
						type="button"
						onClick={this.props.backButton}
						style={{
							borderRadius: "6px",
						}}
					>
						Voltar
					</Button>
				) : null}

				{this.props.nextButton && !this.props.lastPage ? (
					<Button
						variant="secondary"
						type="button"
						color="#9036F7"
						onClick={this.props.nextButton}
					>
						Próximo
					</Button>
				) : null}

				{this.props.pageIsValid === undefined ? null : (
					<Button
						variant="secondary"
						color="#9036F7"
						disabled={!this.props.pageIsValid}
					>
						{!this.props.isEdit ? "Limpar" : "Reverter"}
					</Button>
				)}

				{this.props.hideReload ? null : (
					<Button
						variant="secondary"
						color="#9036F7"
						onClick={this.props.onCleanForm}
					>
						{!this.props.isEdit ? "Limpar" : "Reverter"}
					</Button>
				)}

				<Button
					variant="primary"
					type="submit"
					color="#9036F7"
					onClick={this.props.onSubmit}
					disabled={!this.props.formIsValid}
					title={
						this.props.formIsValid ? "Salvar dados" : "Verifique os campos"
					}
				>
					<span className="text-light">Salvar</span>
				</Button>
			</div>
		);
	}
}

export default FormActions;
